import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../brand/Logo";

export function SiteFooter() {
  return (
    <footer className="border-t border-slate-200/10 bg-background-dark py-14">
      <div className="mx-auto max-w-7xl px-6 md:px-16">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4 mb-12">

          {/* Brand */}
          <div className="col-span-2 md:col-span-1 flex flex-col gap-4">
            <div className="flex items-center gap-1.5">
              <Logo className="h-6 w-auto" />
              <span className="translate-y-0.5 font-black text-white tracking-tight">euteuristix</span>
            </div>
            <p className="text-xs leading-relaxed text-slate-500 max-w-xs">
              Container load planning intelligence. Find the cheapest container mix and pack it perfectly — in one click.
            </p>
            <a
              href="mailto:contact@feuteuristix.com"
              className="text-xs text-slate-500 hover:text-primary transition-colors w-fit"
            >
              contact@feuteuristix.com
            </a>
          </div>

          {/* Product */}
          <div className="flex flex-col gap-3">
            <p className="text-xs font-bold uppercase tracking-widest text-slate-400">Product</p>
            <nav className="flex flex-col gap-2">
              <Link to="/console"        className="text-sm text-slate-500 hover:text-white transition-colors">Console</Link>
              <Link to="/3d-cargo-load-simulator" className="text-sm text-slate-500 hover:text-white transition-colors">Beyond CBM</Link>
              <Link to="/examples"       className="text-sm text-slate-500 hover:text-white transition-colors">Examples</Link>
              <Link to="/pricing"        className="text-sm text-slate-500 hover:text-white transition-colors">Pricing</Link>
              <Link to="/developers"     className="text-sm text-slate-500 hover:text-white transition-colors">API Docs</Link>
              <Link to="/solutions"      className="text-sm text-slate-500 hover:text-white transition-colors">Solutions</Link>
              <Link to="/technology"     className="text-sm text-slate-500 hover:text-white transition-colors">Technology</Link>
            </nav>
          </div>

          {/* Resources */}
          <div className="flex flex-col gap-3">
            <p className="text-xs font-bold uppercase tracking-widest text-slate-400">Resources</p>
            <nav className="flex flex-col gap-2">
              <Link to="/case-studies"                          className="text-sm text-slate-500 hover:text-white transition-colors">Case Studies</Link>
              <Link to="/cbm-calculator"                        className="text-sm text-slate-500 hover:text-white transition-colors">CBM Calculator</Link>
              <Link to="/cbm-calculator#lcl-vs-fcl"           className="text-sm text-slate-500 hover:text-white transition-colors">LCL vs FCL Guide</Link>
              <Link to="/cbm-calculator#chargeable-weight"    className="text-sm text-slate-500 hover:text-white transition-colors">Chargeable Weight</Link>
            </nav>
          </div>

          {/* Company */}
          <div className="flex flex-col gap-3">
            <p className="text-xs font-bold uppercase tracking-widest text-slate-400">Company</p>
            <nav className="flex flex-col gap-2">
              <Link to="/contact-sales"  className="text-sm text-slate-500 hover:text-white transition-colors">Contact Sales</Link>
              <Link to="/privacy"        className="text-sm text-slate-500 hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms"          className="text-sm text-slate-500 hover:text-white transition-colors">Terms of Service</Link>
            </nav>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="flex flex-col items-center justify-between gap-4 border-t border-white/5 pt-8 md:flex-row">
          <p className="text-sm text-slate-600">© 2026 Feuteuristix. All rights reserved.</p>
          <p className="text-xs text-slate-700">Built for logistics teams who move real cargo.</p>
        </div>
      </div>
    </footer>
  );
}
